import { axiosInstance } from '../axios';

const DOCUMENTS_API = '/documents';
class DocumentService {

  async deleteDocument(id){
    return await axiosInstance.delete(`${DOCUMENTS_API}/delete?ids=${id}`);
  }

  async renameDocument(document){
    const requestBody = {
      documentId: document.id,
      newName: document.name,
    };
    return await axiosInstance.post(`${DOCUMENTS_API}/rename`,
      requestBody);}

  async getDocument(documentId){
    return axiosInstance.get(`${DOCUMENTS_API}/${documentId}`);
  }

  async upload(docName, file){
    let formData = new FormData();
    formData.append('file', file);
    formData.append('docName', docName);
    formData.append('fileName', file.name); //camera created file ends up with name blob without this

    return axiosInstance.put('/api/document/create', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  async downloadAndOpen(documentId) {

    return axiosInstance.get(
        `/api/documents/getdocument/${documentId}`,
        {
          responseType: 'blob',
        })
        .then(result => {
          this._showFile(result);
        });
  }

  getDocumentUrl(documentId){
    return axiosInstance.defaults.baseURL + `/api/documents/getdocument/${documentId}`;
  }


  _showFile(result){
    const type = result.headers['content-type'];
    const blob = new Blob([result.data], { type: type });

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob);
      return;
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = this._getFilename(result, null);
    link.click();
    setTimeout(function(){
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  _getFilename(result, fallback){
    const contentDisposition = result.headers['content-disposition'];
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
      if (fileNameMatch.length === 2)
        return fileNameMatch[1];
    }
    return fallback;
  }

}

export default new DocumentService();
